const reportRouters = [
  // 执行管理类报表
  {
    path: "/ExecutiveManage",
    name: "ExecutiveManage",
    component: () => import("@/views/Report/ExecutiveManage.vue"),
    children: [
      {
        path: "admTrackReport",
        name: "admTrackReport",
        component: () =>
          import("@/views/Report/ExecutiveManage/admTrackReport.vue"),
      },
      {
        path: "campusTrackReport",
        name: "campusTrackReport",
        component: () =>
          import("@/views/Report/ExecutiveManage/campusTrackReport.vue"),
      },
      {
        path: "individualReport",
        name: "ExecutiveManage-individualReport",
        component: () =>
          import("@/views/Report/ExecutiveManage/individualReport.vue"),
      },
      {
        path: "PerforMonthReport",
        name: "ExecutiveManage-PerforMonthReport",
        component: () =>
          import("@/views/Report/ExecutiveManage/PerforMonthReport.vue"),
      },
      {
        path: "teacherEnrollmentReport",
        name: "teacherEnrollmentReport",
        component: () =>
          import("@/views/Report/ExecutiveManage/teacherEnrollmentReport.vue"),
      },
    ],
  },

  // 市场分析类报表
  {
    path: "/MarketAnalysis",
    name: "MarketAnalysis",
    component: () => import("@/views/Report/MarketAnalysis.vue"),
    children: [
      {
        path: "admperformReport",
        name: "MarketAnalysis-admperformReport",
        component: () =>
          import("@/views/Report/MarketAnalysis/admperformReport.vue"),
      },
      {
        path: "channelConsultReport",
        name: "MarketAnalysis-channelConsultReport",
        component: () =>
          import("@/views/Report/MarketAnalysis/channelConsultReport.vue"),
      },
      {
        path: "channelCrmDetailReport",
        name: "channelCrmDetailReport",
        component: () =>
          import("@/views/Report/MarketAnalysis/channelCrmDetailReport.vue"),
      },
    ],
  },

  // 跟踪分析类报表
  {
    path: "/TrackAnalysis",
    name: "TrackAnalysis",
    component: () => import("@/views/Report/TrackAnalysis.vue"),
    children: [
      {
        path: "communicationTypeDetailReport",
        name: "communicationTypeDetailReport",
        component: () =>
          import(
            "@/views/Report/TrackAnalysis/communicationTypeDetailReport.vue"
          ),
      },
      {
        path: "CrmMonthReport",
        name: "TrackAnalysis-CrmMonthReport",
        component: () =>
          import("@/views/Report/TrackAnalysis/CrmMonthReport.vue"),
      },
      {
        path: "schoolConsuReport",
        name: "TrackAnalysis-schoolConsuReport",
        component: () =>
          import("@/views/Report/TrackAnalysis/schoolConsuReport.vue"),
      },
      {
        path: "teamEnrollmentReport",
        name: "teamEnrollmentReport",
        component: () =>
          import("@/views/Report/TrackAnalysis/teamEnrollmentReport.vue"),
      },
    ],
  },

  // 活动分析类报表
  {
    path: "/ActivityAnalysis",
    name: "ActivityAnalysis",
    component: () => import("@/views/Report/ActivityAnalysis.vue"),
    children: [
      {
        path: "activitylistDetailReport",
        name: "ActivityAnalysis-activitylistDetailReport",
        component: () =>
          import(
            "@/views/Report/ActivityAnalysis/activitylistDetailReport.vue"
          ),
      },
      {
        path: "PerformanceStatisticsReport",
        name: "ActivityAnalysis-PerformanceStatisticsReport",
        component: () =>
          import("@/views/Report/ActivityAnalysis/PerformanceStatisticsReport.vue"),
      },
    ],
  },

  // 管控分析类报表
  {
    path: "/ControlAnalysis",
    name: "ControlAnalysis",
    component: () => import("@/views/Report/ControlAnalysis.vue"),
    children: [
      // 招生业绩年度汇总表
      {
        path: "EnrollmentPerformanceYearReport",
        name: "EnrollmentPerformanceYearReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentPerformanceYearReport.vue"
          ),
      },
      // 招生业绩月度汇总表
      {
        path: "EnrollmentPerformanceMonthReport",
        name: "EnrollmentPerformanceMonthReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentPerformanceMonthReport.vue"
          ),
      },
      // 招生业绩周度汇总表
      {
        path: "EnrollmentPerformanceWeekReport",
        name: "EnrollmentPerformanceWeekReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentPerformanceWeekReport.vue"
          ),
      },

       // 招生追踪月度统计表
       {
        path: "EnrollmentTrackMonthReport",
        name: "EnrollmentTrackMonthReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentTrackMonthReport.vue"
          ),
      },
      // 招生追踪周度统计表
      {
        path: "EnrollmentTrackWeekReport",
        name: "EnrollmentTrackWeekReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentTrackWeekReport.vue"
          ),
      },

      // 招生邀约状况统计表
      {
        path: "StatisticsEnrollmentInvitationReport",
        name: "StatisticsEnrollmentInvitationReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/StatisticsEnrollmentInvitationReport.vue"
          ),
      },
      // 招生主动到访统计表
      {
        path: "StatisticsVisitEnrollmentReport",
        name: "StatisticsVisitEnrollmentReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/StatisticsVisitEnrollmentReport.vue"
          ),
      },
      // 招生对照明细表
      {
        path: "EnrollmentComparisonDetailReport",
        name: "EnrollmentComparisonDetailReport",
        component: () =>
          import(
            "@/views/Report/ControlAnalysis/EnrollmentComparisonDetailReport.vue"
          ),
      },
    ],
  },

  //分析报表(招生渠道业绩统计表)
  {
    path: "/Analysisreport/admperformReport",
    name: "Analysisreport-admperformReport",
    component: () => import("@/views/Analysisreport/admperformReport.vue"),
  },
  //分析报表(校招生咨询报表)
  {
    path: "/Analysisreport/schoolConsuReport",
    name: "Analysisreport-schoolConsuReport",
    component: () => import("@/views/Analysisreport/schoolConsuReport.vue"),
  },
  // 活动名单明细报表
  {
    path: "/Analysisreport/activitylistDetailReport",
    name: "Analysisreport-activitylistDetailReport",
    component: () =>
      import("@/views/Analysisreport/activitylistDetailReport.vue"),
  },
  //分析报表(个人招生业绩统计表)
  {
    path: "/Analysisreport/individualReport",
    name: "Analysisreport-individualReport",
    component: () => import("@/views/Analysisreport/individualReport.vue"),
  },
  //分析报表(招生月度统计表)
  {
    path: "/Analysisreport/CrmMonthReport",
    name: "Analysisreport-CrmMonthReport",
    component: () => import("@/views/Analysisreport/CrmMonthReport.vue"),
  },
  //分析报表(个人招生月度业绩统计报表)
  {
    path: "/Analysisreport/PerforMonthReport",
    name: "Analysisreport-PerforMonthReport",
    component: () => import("@/views/Analysisreport/PerforMonthReport.vue"),
  },
  //分析报表(渠道咨询报表)
  {
    path: "/Analysisreport/channelConsultReport",
    name: "Analysisreport-channelConsultReport",
    component: () => import("@/views/Analysisreport/channelConsultReport.vue"),
  },
  //分析报表(渠道招生明细表)
  {
    path: "/Analysisreport/channelCrmDetailReport",
    name: "Analysisreport-channelCrmDetailReport",
    component: () =>
      import("@/views/Analysisreport/channelCrmDetailReport.vue"),
  },
  //分析报表(渠道业绩报表)
  {
    path: "/Analysisreport/channelPerfReport",
    name: "Analysisreport-channelPerfReport",
    component: () => import("@/views/Analysisreport/channelPerfReport.vue"),
  },
  //分析报表(校园追踪大表)
  {
    path: "/Analysisreport/admTrackReport",
    name: "Analysisreport-admTrackReport",
    component: () => import("@/views/Analysisreport/admTrackReport.vue"),
  },
  {
    path: "/Analysisreport/communicationTypeDetailReport",
    name: "Analysisreport-communicationTypeDetailReport",
    component: () =>
      import("@/views/Analysisreport/communicationTypeDetailReport.vue"),
  },
  // 活动业绩统计报表
  {
    path: "/Analysisreport/PerformanceStatisticsReport",
    name: "Analysisreport-PerformanceStatisticsReport",
    component: () =>
      import("@/views/Analysisreport/PerformanceStatisticsReport.vue"),
  },
];

export default reportRouters;
